import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { NewsBenefitMetadataExtension } from './extension/news-benefit-metadata.extension';
import { NewsBenefitNavigationExtension } from './extension/news-benefit-navigation.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('news')
    .add(BenefitMetadataExtensionInterface, new NewsBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new NewsBenefitNavigationExtension())
    .build(),
);
